<template>
  <div>
    <section class="literasi">
      <div class="section-one">
        <div class="container">
          <h1 class="section-title" data-aos="fade-up">
            LITERACY AND STEM EDUCATION
          </h1>
          <div class="row justi-content-center">
            <div class="col-lg-12">
              <div class="inner bg">
                <p data-aos="fade-down" data-aos-delay="700">
                  According to the World Economic Forum’s 2020 Annual Gender Gap
                  Report, the educational gender gap is relatively small.
                  However, there is still a small number of countries that are
                  far behind. In countries where quality education is achieved,
                  discrepancies remain when it comes to employing women with
                  high levels of education.
                </p>
                <p data-aos="fade-down" data-aos-delay="800">
                  Access to primary, secondary and tertiary education in
                  addition to literacy rates are key indicators to assess the
                  development of girls and women in education. Girls and women
                  face various barriers and challenges when trying to attain an
                  education, including poverty, early marriage and violence.
                </p>
                <p data-aos="fade-down" data-aos-delay="800">
                  The gender gap in terms of literacy has reduced drastically in
                  recent years. However, the MENA region still lags behind in
                  comparison to other regions that have almost closed the gap
                  altogether.
                </p>
              </div>
              
            </div>
          </div>
           <div class="row justify-content-center">
            <div class="col-lg-7">
              <div
                class="box mt-20"
                data-aos="fade-down"
                data-aos-duration="1500"
              >
                <ul>
                  <li>
                    <div class="icon degree">
                      <img src="@/assets/images/icons/degree.svg" alt="" />
                    </div>
                    <div>
                      <span class="counter" data-number="132">0</span><span>million</span><br>
                      girls are out school around the world
                    </div>
                  </li>
                  <li>
                    <div class="icon currency">
                      <img src="@/assets/images/icons/currency.svg" alt="" />
                    </div>
                    <div>
                      Low-income families favor boys when investingin education
                    </div>
                  </li>
                </ul>
                <ul class="data">
                  <li>
                    <span>1 out of 3</span><br />
                    adolescent girls from underprivileged backgrounds have never
                    been to school
                  </li>
                  <li class="women-icon">
                    <img src="@/assets/images/icons/women-icon.svg" alt="" />
                  </li>
                  <li>
                    <span>Over 1/3</span><br />
                    of adolescent girls aged 15-17 are out of school across the
                    MENA region
                  </li>
                </ul>
                <div class="link">
                  <a
                    target="_blank"
                    href="https://www.unicef.org/education/girls-education"
                    >Figure 3 - Gender Gap in Education:
                    https://www.unicef.org/education/girls-education</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="row justi-content-center">
            <div class="col-lg-10">
                <div class="main-map">
                    <img src="@/assets/images/map.png" alt="">
                </div>
                <div class="box bg-none">
                  <div class="link">
                    <a target="_blank"
                      href="https://blogs.worldbank.org/opendata/more-men-women-are-literate">
                      Figure 4 - Literacy Rate by Region:
                      https://blogs.worldbank.org/opendata/more-men-women-are-literate
                    </a>
                  </div>
              </div>
            </div>
          </div>
         
        </div>
      </div>
      <div class="section-two">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="inner">
                <p data-aos="fade-down">
                  Figure 5 provides the rates of girls who are out of school as
                  per Zain’s operating countries.It is evident that some of our
                  markets face greater gaps related to girls who are out of
                  school. When it comes to the region as a whole, there is still
                  a long way to go in addressing the literacy gender gap, the
                  narrowing of which will allow women to participate in the
                  labor market and help uplift disadvantaged communities.
                </p>
              </div>
              <div class="box map">
                <div class="chart-wrapper">
                  
                </div>
                <div class="link">
                  <a
                    target="_blank"
                    href="https://data.worldbank.org/indicator/SE.PRM.UNER.ZS">
                    Figure 5:
                    https://data.worldbank.org/indicator/SE.PRM.UNER.ZS<br />
                  </a>
                  <a
                    target="_blank"
                    href="https://www.unicef.org/mena/media/6506/file/Iraq%20Country%20Report%20on%20OOSC%20Summary_EN.pdf%20.pdf"
                    >https://www.unicef.org/mena/media/6506/file/Iraq%20Country%20Report%20on%20OOSC%20Summary_EN.pdf%20.pdf</a
                  >
                </div>
              </div>
              <h4 class="yellow" data-aos="fade-down">ZAIN’S RESPONSE</h4>
              <div class="inner p-0" data-aos="fade-down">
                <p>
                  Under Zain’s Generation Youth and Inclusion pillars, the
                  company has set targets to address challenges brought up
                  through gender inequality. The targets vary based on markets
                  and the context of each operation. The following are the focus
                  areas and KPIs set out to tackle the challenges highlighted in
                  the figure above.
                </p>
              </div>
            </div>
            <div class="col-lg-6 right">
              <div class="row">
                <div class="col-md-6">
                  <div
                    class="box"
                    data-aos="flip-left"
                    data-aos-duration="2000"
                  >
                    <div class="icon inclusion-icon">
                      <img src="@/assets/images/icons/inclusion.svg" alt="" />
                    </div>
                    <ul>
                      <li>
                        <span>INCLUSION</span><br />
                        Bridging the inequality gap
                      </li>
                    </ul>
                    <div class="bg-color">
                      <div class="image women-technology-icon">
                        <img
                          src="@/assets/images/icons/women-technology.svg"
                          alt=""
                        />
                      </div>
                      <span>Women in Technology</span>
                      <p>
                        Promote gender equality in Science, Technology,
                        Engineering and Math (STEM) related fields
                      </p>
                      <p>
                        Advocate and mentor girls and young women in schools and
                        universities to support them in entering STEM-related
                        fields
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div
                    class="box"
                    data-aos="flip-right"
                    data-aos-duration="2000"
                  >
                    <div class="icon financial-inclusion-icon">
                      <img
                        src="@/assets/images/icons/financial-inclusion-icon2.svg"
                        alt=""
                      />
                    </div>
                    <ul>
                      <li>
                        <span>GENERATION YOUTH</span><br />
                        Address 16 million children and youth across our markets
                      </li>
                    </ul>
                    <div class="bg-color">
                      <div class="image digital-phone-icon">
                        <img
                          src="@/assets/images/icons/digital-phone.svg"
                          alt=""
                        />
                      </div>
                      <span>Digital Literacy</span>
                      <p>
                        Equip 943,000 children with digital literacy skills
                      </p>
                      <p>
                        Increase accessibility to online educational platforms
                        and measure the gender gap
                      </p>
                      <div class="border-bottom"></div>
                      <div class="image unemployment-icon">
                        <img
                          src="@/assets/images/icons/unemployment.svg"
                          alt=""
                        />
                      </div>
                      <span>Youth Unemployment</span>
                      <p>
                        Provide unemployed youth with training, skills,
                        workshops and mentorship opportunities
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-three">
        <div class="container">
          <div class="row">
            <div class="col-xl-6">
              <div class="image" data-aos="zoom-in" data-aos-duration="2000">
                <img
                  src="@/assets/images/girls-education.png"
                  class="img-fluid"
                  alt=""
                />
              </div>
              <h4 data-aos="fade-down" data-aos-duration="300">
                IMPACT OF GIRLS’ EDUCATION
              </h4>
              <div class="inner bg">
                <p data-aos="fade-down" data-aos-duration="400">
                  Empowering girls through education and providing them equal
                  access to attaining a degree is not only considered a human
                  right but also benefits society directly. Many sources even
                  claim that it leads to saving and improving lives.
                </p>
                <p data-aos="fade-down" data-aos-duration="500">
                  According to the World Economic Forum’s 2020 Gender Gap
                  report, educational attainment is considered one of the
                  progressive aspects of addressing gender disparity as many
                  countries have continued to invest in education for girls and
                  have thus minimized the gap at an exponential rate. The report
                  states that 35 countries around the world have closed the gap,
                  which is a great achievement, though it highlights that most
                  countries globally still have work to do. In particular,
                  developing countries are considered to be behind, as 10% of
                  girls are considered illiterate in such regions.
                </p>
                <p data-aos="fade-down" data-aos-duration="600">
                  According to ‘Theirworld Organization’, a children’s charity
                  that is committed to ending the global education crisis, there
                  are various positive outcomes of girls’ education on society,
                  including:
                </p>
              </div>
              <ul class="list-items">
                <li data-aos="fade-down" data-aos-duration="700">
                  <span>1.</span>
                  Economic growth
                </li>
                <li data-aos="fade-down" data-aos-duration="800">
                  <span>2.</span>
                  Health knowledge saves children’s lives
                </li>
                <li data-aos="fade-down" data-aos-duration="800">
                  <span>3.</span>
                  Smaller and more sustainable families
                </li>
                <li data-aos="fade-down" data-aos-duration="900">
                  <span>4.</span>
                  Reduced HIV/AIDS and malaria infection rates
                </li>
                <li data-aos="fade-down" data-aos-duration="1000">
                  <span>5.</span>
                  Fewer girls in child marriages
                </li>
                <li data-aos="fade-down" data-aos-duration="1100">
                  <span>6.</span>
                  Better prepared for natural disasters and climate change
                </li>
                <li data-aos="fade-down" data-aos-duration="1200">
                  <span>7.</span>
                  More control over their lives
                </li>
                <li data-aos="fade-down" data-aos-duration="1300">
                  <span>8.</span>
                  More skills to become leaders
                </li>
              </ul>
            </div>
            <div class="col-xl-6">
              <h4 data-aos="fade-left" data-aos-duration="300">
                STEM EDUCATION
              </h4>
              <div class="inner bg">
                <p data-aos="fade-down" data-aos-duration="400">
                  As the number of girls gaining an education increases,
                  disparities associated with access to opportunities, quality
                  and topics they choose to study becomes more evident. Such
                  inequalities can hold girls back from reaching their full
                  potential, thus it is imperative for girls to further develop
                  themselves in STEM education, as careers in these areas are
                  seen as the ‘jobs of the future’, driving innovation, social
                  well-being, inclusive growth and sustainable development.<a
                    target="_blank"
                    href="https://en.unesco.org/stemed"
                    ><sup>4</sup></a
                  >
                </p>
                <p data-aos="fade-down" data-aos-duration="500">
                  STEM education holds tremendous promise for girls and women.
                  Gender biases and barriers that currently exist are a setback
                  to girls and women gaining STEM skills. Even in countries
                  where girls can afford to attain a STEM-related degree, their
                  transition into the workforce is a process that can be
                  extremely difficult. In developing countries, women are 9%
                  less likely than men to enroll in programs in engineering and
                  mathematics-related fields. Whereas women in high income
                  counties are 15-17% less likely to join such fields. As
                  indicated in Figure 6, the proportion of women in STEM in the
                  MENA region is the highest in the world and exceeds the
                  world’s average. This highlights a major opportunity for the
                  MENA region to really drive equitable gender representation in
                  STEM employment.
                </p>
              </div>
              <div
                class="box graph mt-20"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <ul>
                  <li>
                    <span class="yellow">
                      The MENA region has the highest share of women among total
                      tertiary STEM graduates in the world
                    </span>
                  </li>
                </ul>
                <div id="chart" class="chart">
                  <VueApexCharts
                    ref="chart"
                    type="bar"
                    :options="options"
                    :series="series"
                  ></VueApexCharts>
                </div>
                <div class="link">
                  <a
                    target="_blank"
                    href="https://twitter.com/efe_global/status/1239884650971086851"
                  >
                    Figure 6: Share of women among total tertiary STEM graduates, average
                    annual rates, latest hears, results by world and region:
                    <br />https://twitter.com/efe_global/status/1239884650971086851
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span
          class="graphics"
          data-aos="zoom-in"
          data-aos-duration="2000"
          data-aos-delay="300"
          ><img src="@/assets/images/graphics/graphic-5.png" alt=""
        /></span>
      </div>
      <div class="section-four">
        <span
          class="graphics"
          data-aos="zoom-in-left"
          data-aos-duration="2000"
          data-aos-delay="300"
          ><img src="@/assets/images/graphics/graphic-7.png" alt=""
        /></span>
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="inner bg">
                <p data-aos="fade-down">
                  Different segments of society must invest in STEM education
                  for girls and women given that secluding them will potentially
                  lead to significantly negative consequences.<a
                    target="_blank"
                    href="https://www.cfr.org/blog/investing-girls-stem-education"
                    ><sup>5</sup></a
                  >
                </p>
                <p data-aos="fade-down">
                  According to the Council on Foreign Relations Organization,
                  improving opportunities for girls in STEM could be achieved
                  through four major steps.
                </p>
              </div>
              <div class="box">
                <ul>
                  <li data-aos="fade-up" data-aos-duration="1000">
                    <span>1</span>
                    Invest and donate money to programs that aim to increase
                    girls education in STEM
                    <div class="icon currency-icon">
                      <img src="@/assets/images/icons/currency.svg" alt="" />
                    </div>
                  </li>
                  <li data-aos="fade-up" data-aos-duration="1200">
                    <span>2</span>
                    Aggregate data that monitors the gender gap in STEM
                    education
                    <div class="icon statistics-icon">
                      <img src="@/assets/images/icons/statistics.svg" alt="" />
                    </div>
                  </li>
                </ul>
                <ul>
                  <li data-aos="fade-up" data-aos-duration="1400">
                    <span>3</span>
                    Leverage public-private partnerships that translate STEM
                    education into employment
                    <div class="icon partnership-icon">
                      <img src="@/assets/images/icons/partnership.svg" alt="" />
                    </div>
                  </li>
                  <li data-aos="fade-up" data-aos-duration="1600">
                    <span>4</span>
                    Spark a global movement to invest in girls’ STEM education
                    around the world
                    <div class="icon degree-icon">
                      <img src="@/assets/images/icons/degree.svg" alt="" />
                    </div>
                  </li>
                </ul>
                <div class="link">
                  <a
                    target="_blank"
                    href="https://www.cfr.org/blog/investing-girls-stem-education"
                    >Figure 7:
                    https://www.cfr.org/blog/investing-girls-stem-education</a
                  >
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inner bg">
                <p data-aos="fade-down">
                  To create a holistic transformation and revolutionize girls’
                  inclusion in STEM education, all segments of society should
                  contribute and commit to doing so. Policymakers, educators,
                  private companies, civil society and organizations should
                  proactively support girls and women in entering the field.
                </p>
                <p data-aos="fade-down">
                  The following are case studies on how different sectors are
                  contributing to encouraging girls pursuing STEM.
                </p>
              </div>
              <h4 class="mt-20" data-aos="fade-up">NON-PROFIT SECTOR:</h4>
              <div class="inner bg">
                <p data-aos="fade-down">
                  Code to Inspire is an organization that empowers women in
                  Afghanistan with tech-related tools, knowledge and skills to
                  enhance and develop their coding skills. Established in 2015,
                  the initiative is the first coding school in Afghanistan that
                  is focused on providing such skills to women.
                </p>
              </div>
              <h4 class="mt-20" data-aos="fade-up">IMPACT:</h4>
              <div class="box">
                <ul class="justify-content-center">
                  <li data-aos="fade-up" data-aos-duration="1000">
                    <span class="yellow">
                      150 young women
                    </span>
                    were taught how to code, build mobile apps and games
                  </li>
                </ul>
                <ul class="justify-content-center">
                  <li data-aos="fade-up" data-aos-duration="1000">
                    <span class="yellow">
                      Over <span class="counter" data-number="70"></span><span
                        >%</span
                      >
                    </span>
                    of graduates have found work, earning above average wages in
                    their country
                  </li>
                </ul>
                <div class="link">
                  <a target="_blank" href="https://www.codetoinspire.org/"
                    >Figure 8: https://www.codetoinspire.org/</a
                  >
                  <a
                    target="_blank"
                    href="https://girlswhostem.com/best-stem-organizations-for-girls-and-women/"
                    >https://girlswhostem.com/best-stem-organizations-for-girls-and-women/</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-five">
        <span
          class="graphics"
          data-aos="zoom-in-right"
          data-aos-duration="2000"
          data-aos-delay="300"
          ><img src="@/assets/images/graphics/graphic-1.png" alt=""
        /></span>
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <h4 data-aos="fade-down" data-aos-duration="300">
                GOVERNMENTAL SECTOR:
              </h4>
              <div class="inner bg">
                <p data-aos="fade-down">
                  The Australian government’s strategy for women in STEM aims to
                  increase gender equity in STEM-related education and
                  employment. The government has identified three focus areas
                  that will help achieve its goals: enabling STEM through
                  education, supporting STEM careers and highlighting STEM
                  women.
                </p>
              </div>
              <h4 data-aos="fade-down" data-aos-duration="300">IMPACT:</h4>
              <div class="box">
                <ul>
                  <li data-aos="fade-down" data-aos-duration="1000">
                    <div class="icon launch-icon">
                      <img src="@/assets/images/icons/launch-icon.svg" alt="" />
                    </div>
                    <p>
                      Launched the Science in Australia Gender Equity (SAGE)
                      Program
                    </p>
                  </li>
                </ul>
                <ul>
                  <li data-aos="fade-down" data-aos-duration="1200">
                    <div class="icon currency-icon">
                      <img src="@/assets/images/icons/currency.svg" alt="" />
                    </div>
                    <p>
                      Anonymizing research funding proposals to ensure equality
                    </p>
                  </li>
                </ul>
                <ul>
                  <li data-aos="fade-down" data-aos-duration="1400">
                    <div class="icon location-icon">
                      <img src="@/assets/images/icons/location.svg" alt="" />
                    </div>
                    <p>
                      Established a STEM Equity Monitor to track system-level
                      change to provide consistent sources of evidence
                    </p>
                  </li>
                </ul>
                <div class="link">
                  <a
                    target="_blank"
                    href="https://www.industry.gov.au/sites/default/files/March%202020/document/advancing-women-in-stem-strategy-action-pan-2020-1.pdf"
                    >Figure 9:
                    https://www.industry.gov.au/sites/default/files/March%202020/document/advancing-women-in-stem-strategy-action-pan-2020-1.pdf</a
                  >
                  <a
                    target="_blank"
                    href="https://www.industry.gov.au/data-and-publications/advancing-women-in-stem-strategy/2020-action-plan"
                    >https://www.industry.gov.au/data-and-publications/advancing-women-in-stem-strategy/2020-action-plan</a
                  >
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <h4 data-aos="fade-left" data-aos-duration="300">
                FOR-PROFIT SECTOR:
              </h4>
              <div class="inner bg">
                <p data-aos="fade-down">
                  Zain Bahrain’s Girls for Tech Camp was launched in partnership
                  with the Supreme Council for Women and Clever Play, which is
                  an organization that aims to inspire children’s curiosity and
                  passion for STEM. Established in October 2019, the program
                  aims to equip 1,000 girls between the of ages 8 and 14 years
                  with 10 hours of training in coding.
                </p>
              </div>
              <h4 data-aos="fade-left" data-aos-duration="300">IMPACT:</h4>
              <div class="box  right">
                <ul>
                  <li data-aos="fade-left" data-aos-duration="1000">
                    In 2019-2020,<br />
                    <span class="counter" data-number="1000">0</span
                    ><span> girls</span>
                    completed the program. Due to COVID-19, the company had to
                    pause the program, however, it was able to resume online in
                    August 2020.
                  </li>
                </ul>
                <ul>
                  <li data-aos="fade-left" data-aos-duration="1000">
                    Provide exposure to <br />
                    <span>future career paths in STEM fields</span>
                    including environmental science, software development,
                    computer analytics, robotics and data science.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export default {
  components: {
    VueApexCharts
  },
  data: function() { 
    return {
        options: {
            chart: {
                width: "100%",
                height: 350,
                id: "vuechart-example",
                foreColor: "#373d3f",
                animations: {
                    enabled: true,
                    easing: "easeinout",
                    speed: 800,
                    animateGradually: {
                        enabled: true,
                        delay: 150
                    },
                    dynamicAnimation: {
                        enabled: true,
                        speed: 350
                    }
                }
            },
            xaxis: {
                categories: [
                "World",
                [ 'Middle East and','North Africa'],
                ['Asia and','the Pacific' ],
                ['Europe and','Central Asia'],
                "Africa",
                "Americas"
                ]
            },
            dataLabels: {
                style: {
                    colors: ["#52b9e9", "#E91E63", "#9C27B0"]
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true
                }
            },
            responsive: [
                {
                    breakpoint: 600,
                    options: {
                        chart:{
                            height: 400
                        },
                        plotOptions: {
                            bar: {
                                horizontal: false,
                                columnWidth: '70%',
                            }
                        },
                        dataLabels: {
                            style: {
                                colors: ["#52b9e9", "#E91E63", "#9C27B0"]
                            }
                        },
                        legend: {
                            position: "bottom",
                            fontSize: '8px',
                            show: false,
                        }
                    }
                }
            ]
        },
        series: [
            {
                name: "series-1",
                data: [37.8, 49.2, 40.4, 33.7, 33.0, 32.9]
            }
        ],
    };
  },
  mounted() {
    this.$refs.chart.destroy();
    this.counterAnimation();
    this.chartAnimation();
  },
  methods: {
    chart: function() {
      this.$refs.chart.init();
    },
    chartAnimation: function() {
      let tl = gsap.timeline();
      tl.from(".chart", {
        opacity: 1,
        scrollTrigger: {
          trigger: ".chart",
          start: "top 90%",
          end: "top 55%",
          markers: false,
          scrub: 1,
          once: true,
          onEnter: ({ progress, direction, isActive }) => this.chart()
        }
      });
    }
  }
};
</script>
<style scoped>
.chart{
    max-width: 500px;
}
</style>
